// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetail_container__2dUdD","products":"OrderDetail_products__4gZwJ"};